import React from 'react';
import { Alert } from '@/experiences/sales-portal/domain/insights/blocs/types/alert';
import { AlertCard } from '@/experiences/sales-portal/domain/insights/components/alert-card/alert-card';
import { AlertCardSurface } from '@/experiences/sales-portal/domain/insights/components/alert-card/alert-card-surface';
import { createStyles } from '@/contexts/theme-context';
import { FlatList } from 'react-native';
import { hiddenAlertActions } from '@/experiences/sales-portal/domain/insights/components/hidden-alert-actions';
import { Spacer } from '@usepepper/sprout-kit-ui';
import { UseAlertPressResult } from '@/experiences/sales-portal/domain/insights/blocs/hooks/use-alert-press';

const INITIAL_ROWS = 5;

interface InsightsMobileHiddenAlertsListProps extends UseAlertPressResult {
  alerts: Alert[];
  bottomInset: number;
  onDelete: (alert: Alert) => void;
  onRestore: (alert: Alert) => void;
}

export const InsightsMobileHiddenAlertsList: React.FC<
  InsightsMobileHiddenAlertsListProps
> = ({
  alerts,
  bottomInset,
  onAccountDetailPress,
  onAlertPress,
  onDelete,
  onRestore,
}) => {
  const [styles] = useStyles();

  return (
    <FlatList
      contentContainerStyle={[styles.content, { paddingBottom: bottomInset }]}
      data={alerts}
      initialNumToRender={INITIAL_ROWS}
      keyExtractor={(item) => item.alertUUID}
      renderItem={({ item }) => (
        <AlertCardSurface>
          <AlertCard
            actions={hiddenAlertActions(item, { onDelete, onRestore })}
            alert={item}
            onAlertCardPress={onAccountDetailPress(item)}
            onContentPress={onAlertPress(item)}
          />
          <Spacer size="$16" />
        </AlertCardSurface>
      )}
      style={styles.list}
    />
  );
};

const useStyles = createStyles((theme) => ({
  content: {
    gap: theme.sk.spacing.spaceSmall,
    paddingHorizontal: theme.sk.spacing.spaceMedium,
    paddingTop: theme.sk.spacing.spaceSMedium,
  },
  list: {
    flex: 1,
  },
}));
